import gql from 'graphql-tag';
import { clients } from '../../../util/clients';
import {
  fieldsToGqlString,
} from '../../../util/shared/vue-global';

const { backend } = clients.direct;

const defaultInterestApportionmentFields = {
  endingBalanceDayWise: '',
  fundWiseInterestDetails: '',
  fundWiseInterestDetailsWithTaxUnits: '',
};

export const interestApportionment = {
  namespaced: true,
  state: () => ({
    fiscalYearForMiscReceipt: null,
  }),
  mutations: {
    setFiscalYearForMiscReceipt(state, fiscalYear) {
      state.fiscalYearForMiscReceipt = fiscalYear;
    },
  },
  actions: {
    async loadInterestApportionment({ commit, dispatch }, {
      criteria, fields, baseCrudKey,
    }) {
      let results;
      const gqlfields = fields || defaultInterestApportionmentFields;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql` query glInterestApportionment($criteria: glInterestApportionmentCriteriaType) {
            glInterestApportionment(criteria: $criteria) {
                ${fieldsToGqlString(gqlfields)},
              }
            }`,
          variables: { criteria },
          fetchPolicy: 'no-cache',

        });
        clients.handleGQLErrors(results, commit);
        const glInterestApportionmentResult = results.data ? results.data.glInterestApportionment
          || {} : {};
        // console.info('---glInterestApportionmentResult--', glInterestApportionmentResult);
        commit('base/crud/setItems', [baseCrudKey, glInterestApportionmentResult], { root: true });
        return glInterestApportionmentResult;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was problem loading the Transaction List!', { root: true });
      }
      return [];
    },
  },
};

export default interestApportionment;
